document.addEventListener('DOMContentLoaded', function () {
  var timers = document.querySelectorAll('.rv-countdown-timer');
  timers.forEach(function (timer) {
    var target = new Date(timer.dataset.target).getTime();
    if (isNaN(target)) return;

    function update() {
      var diff = target - Date.now();
      if (diff <= 0) {
        timer.innerHTML = '<span class="rv-countdown-live">CANLI</span>';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      var dEl = timer.querySelector('[data-days]');
      var hEl = timer.querySelector('[data-hours]');
      var mEl = timer.querySelector('[data-minutes]');
      var sEl = timer.querySelector('[data-seconds]');

      if (dEl) dEl.textContent = String(d).padStart(2, '0');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  });
});
